import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import Input from "../../../../common/component/Input";
import { capitalizeFirstLetter } from "../../../../../../helpers/functions";
import AntSelect, { AntOption } from "../../../../common/component/AntSelect";
import { useTranslation } from "react-i18next";
import "./CampaignPromotionInfoSection.less";
import TextArea from "../../../../common/component/TextArea";
import GuestEmails from "../GuestEmails";
import UploadImage from "../../../../common/component/UploadImage";
import DEFINE, {
  CAMPAIGN,
  DETAIL_ACTIONS,
  UPLOAD_DIRECTORY
} from "../../../../../../constants/Define";
import { getCreateType } from "../utils";

const defaultCollapseKey = "campaignPromotionInfoSection";
const UPLOAD_FILE_TYPE = {
  AVATAR: "AVATAR",
  COVER: "COVER"
};

const getSrc = file => {
  const src = file?.fileUri ?? file?.fileUrl;
  if (src && src.startsWith(DEFINE.GENERAL.CDN_IMG_DEFAULT)) {
    return [src];
  }
  return src ? [`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${src}`] : null;
};

const getDefaultImageState = src => {
  if (src)
    return {
      fileUrl: src
    };
  return null;
};

function CampaignPromotionInfoSection(props) {
  const {
    promotionCampaign,
    validation,
    isLoyaltyPromotion,
    handleSwitchChange,
    action,
    onChange,
    onUploadFile,
    file,
    campaign
  } = props;
  const { pcAvatar, pcCover } = promotionCampaign;
  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();
  const [isAvatarUploading, setAvatarUploading] = useState(false);
  const [avatarFile, setAvatarFile] = useState();
  const [isCoverUploading, setCoverUploading] = useState(false);
  const [coverFile, setCoverFile] = useState();
  const isFnbCampaign = (campaign.productType || []).includes(
    CAMPAIGN.PRODUCT_TYPE.FNB.value
  );
  const pcLableWordingMaxLength = isFnbCampaign ? 10 : 20;

  const onToggleCollapse = () => {
    if (collapseKey) {
      // close
      setCollapseKey();
    } else {
      // open
      setCollapseKey(defaultCollapseKey);
    }
  };

  useEffect(() => {
    const hasError =
      validation &&
      (validation.pcDisplayName ||
        validation.pcDescription ||
        validation.pcLableWording ||
        validation.pcDisplayTarget ||
        validation.pcCtaName);
    if (hasError && !collapseKey) {
      setCollapseKey(defaultCollapseKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validation]);

  useEffect(() => {
    setAvatarFile(getDefaultImageState(pcAvatar));
  }, [pcAvatar]);

  useEffect(() => {
    setCoverFile(getDefaultImageState(pcCover));
  }, [pcCover]);

  useEffect(() => {
    const { isFetching, file: uploadedFileInfo } = file || {};
    if (isFetching) return;
    const uploadedFile = uploadedFileInfo?.data;
    if (isAvatarUploading) {
      setAvatarFile(uploadedFile);
      setAvatarUploading(false);
      const src = getSrc(uploadedFile);
      onChange("pcAvatar", src ? src[0] : null);
    }
    if (isCoverUploading) {
      setCoverFile(uploadedFile);
      setCoverUploading(false);
      const src = getSrc(uploadedFile);
      onChange("pcCover", src ? src[0] : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file, isAvatarUploading, isCoverUploading]);

  const renderLoyaltyForm = () => (
    <Wrapper className={"row campaign-collapse-row"}>
      <Wrapper className="col-md-6">
        <span>
          {t("item.campaign.campaignPromotionInfoSection.loyaltyDescription")}
        </span>
      </Wrapper>
    </Wrapper>
  );

  const uploadFile = (file, type) => {
    if (type === UPLOAD_FILE_TYPE.AVATAR) {
      setAvatarUploading(true);
    } else {
      setCoverUploading(true);
    }
    onUploadFile({
      file: file.target.files[0],
      directory: UPLOAD_DIRECTORY.CAMPAIGN_THUMB,
      isFile: 1
    });
  };

  const onRemoveAvatar = () => {
    setAvatarFile();
    onChange("pcAvatar", null);
  };
  const onRemoveCover = () => {
    setCoverFile();
    onChange("pcCover", null);
  };

  const avatarThumb = useMemo(() => {
    return getSrc(avatarFile);
  }, [avatarFile]);

  const coverThumb = useMemo(() => {
    return getSrc(coverFile);
  }, [coverFile]);

  const renderVPTForm = () => {
    return (
      <>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={promotionCampaign.pcDisplayName}
              validation={validation.pcDisplayName}
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.displayName`
              )}
              // visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Input
                type="text"
                autoComplete="off"
                placeholder={capitalizeFirstLetter(
                  t(
                    "item.campaign.campaignPromotionInfoSection.vptPlaceholder.displayName"
                  ).toLowerCase()
                )}
                className="form-control"
                name="name"
                onChange={e => onChange("pcDisplayName", e.target.value)}
                value={promotionCampaign?.pcDisplayName ?? ""}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={promotionCampaign.pcDescription}
              validation={validation.pcDescription}
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.description`
              )}
              // visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <TextArea
                rows={2}
                placeholder={capitalizeFirstLetter(
                  t(
                    "item.campaign.campaignPromotionInfoSection.vptPlaceholder.description"
                  ).toLowerCase()
                )}
                value={promotionCampaign.pcDescription}
                onChange={e => onChange("pcDescription", e.target.value)}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.detail`
              )}
              // visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <TextArea
                rows={3}
                value={promotionCampaign.pcDetail}
                onChange={e => onChange("pcDetail", e.target.value)}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              typeInput={true}
              classLabel="col-md-12"
              classInputForm="col-md-12"
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.avatar`
              )}
              className="mb-0"
              // visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <UploadImage
                multiple={false}
                isPreview3x3={true}
                loading={isAvatarUploading}
                thumbnailSize={"100%"}
                buttonSize={120}
                thumbnailStyle={{ maxHeight: 120 }}
                uploadText={t("item.tour.uploadFile")}
                loadingText={t("item.tour.uploading")}
                onChange={file => uploadFile(file, UPLOAD_FILE_TYPE.AVATAR)}
                onRemoveThumbnail={onRemoveAvatar}
                thumbnails={avatarThumb}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              typeInput={true}
              classLabel="col-md-12"
              classInputForm="col-md-12"
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.coverPicture`
              )}
              className="mb-0"
              // visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <UploadImage
                multiple={false}
                isPreview3x3={true}
                loading={isCoverUploading}
                thumbnailSize={"100%"}
                buttonSize={120}
                thumbnailStyle={{ maxHeight: 120 }}
                uploadText={t("item.tour.uploadFile")}
                loadingText={t("item.tour.uploading")}
                onChange={file => uploadFile(file, UPLOAD_FILE_TYPE.COVER)}
                onRemoveThumbnail={onRemoveCover}
                thumbnails={coverThumb}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={promotionCampaign.pcLableWording}
              validation={validation.pcLableWording}
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.lableWording`
              )}
              // visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Input
                type="text"
                autoComplete="off"
                placeholder={capitalizeFirstLetter(
                  t(
                    `item.campaign.campaignPromotionInfoSection.vptPlaceholder.${
                      isFnbCampaign ? "fnbLableWording" : "lableWording"
                    }`
                  ).toLowerCase()
                )}
                className="form-control"
                name="description"
                maxLength={pcLableWordingMaxLength}
                onChange={e => onChange("pcLableWording", e.target.value)}
                value={promotionCampaign?.pcLableWording ?? ""}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={promotionCampaign.pcCtaName}
              validation={validation.pcCtaName}
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.ctaName`
              )}
              // visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Input
                type="text"
                autoComplete="off"
                placeholder={capitalizeFirstLetter(
                  t(
                    "item.campaign.campaignPromotionInfoSection.vptPlaceholder.ctaName"
                  ).toLowerCase()
                )}
                className="form-control"
                name="description"
                onChange={e => onChange("pcCtaName", e.target.value)}
                value={promotionCampaign?.pcCtaName ?? ""}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              dataValidation={promotionCampaign.pcDisplayTarget}
              validation={validation.pcDisplayTarget}
              messageBelowInput={true}
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.displayTarget`
              )}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <AntSelect
                className="select-types"
                showArrow
                mode="multiple"
                placeholder={capitalizeFirstLetter(
                  t(
                    "item.campaign.campaignPromotionInfoSection.selectTargetPlaceholder"
                  ).toLowerCase()
                )}
                value={promotionCampaign.pcDisplayTarget}
                onChange={channel => onChange("pcDisplayTarget", channel)}
                style={{ width: "100%" }}
              >
                {Object.keys(CAMPAIGN.MEMBER_SHIP_TYPE).map(key => {
                  const item = CAMPAIGN.MEMBER_SHIP_TYPE[key];
                  return (
                    <AntOption key={item.id} value={item.id}>
                      {item.label}
                    </AntOption>
                  );
                })}
              </AntSelect>
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              labelTitle={t(
                `item.campaign.campaignPromotionInfoSection.specifyTarget`
              )}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Wrapper className="col-md-12" style={{ padding: "unset" }}>
                <GuestEmails
                  onChange={(type, data) => {
                    if (type === "emails") {
                      onChange("pcEmails", data, () => {
                        onChange("pcEmailSuffix", null);
                      });
                    }
                    if (type === "emailSuffix") {
                      onChange("pcEmailSuffix", data, () => {
                        onChange("pcEmails", null);
                      });
                    }
                  }}
                  lstEmails={promotionCampaign?.pcEmails ?? []}
                  lstEmailSuffix={promotionCampaign?.pcEmailSuffix ?? []}
                  canEdit={true}
                  visible={true}
                  buttonText={t(
                    `item.campaign.campaignPromotionInfoSection.emailTargetConfig`,
                    totalEmail
                  )}
                />
              </Wrapper>
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
      </>
    );
  };

  const titleName = useMemo(() => {
    const name = campaign?.name ?? "";
    return { name };
  }, [campaign]);

  const totalEmail = useMemo(() => {
    const pcEmailSuffix = promotionCampaign?.pcEmailSuffix ?? [];
    const pcEmails = promotionCampaign?.pcEmails ?? [];
    let total = pcEmails.length;
    total = total !== 0 ? total : pcEmailSuffix.length;
    return { email: total };
  }, [promotionCampaign]);

  const getStateToggleLoyalty = () => {
    if (action === DETAIL_ACTIONS.TRANSLATE) return true;
    if (!campaign) return true;
    const createType = getCreateType(campaign);
    if (!createType) return true;
    const { key } = createType;
    const { isLoyaltyVoucher, isLoyaltyBenefit } = campaign;

    if ((key === "sku" || key === "fnb") && !isLoyaltyVoucher) {
      return true;
    }
    // if (key === "hotel" && isLoyaltyBenefit) {
    //   return true;
    // }
    if (key === "hotel" && !isLoyaltyBenefit && !isLoyaltyVoucher) {
      return true;
    }
    if (key === "markup") {
      return true;
    }
  };

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.campaignPromotionInfoSection.headerTitle")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-12">
            <h3>
              {t("item.campaign.campaignPromotionInfoSection.title", titleName)}
            </h3>
          </Wrapper>
          <Wrapper className="col-md-12">
            <Switch
              checked={!isLoyaltyPromotion}
              disabled={getStateToggleLoyalty()}
              className="royalty-promotion-campaign-switch"
              checkedChildren={t(
                "item.campaign.campaignPromotionInfoSection.SwitchVPT"
              )}
              unCheckedChildren={t(
                "item.campaign.campaignPromotionInfoSection.SwitchLoyalty"
              )}
              onClick={() => handleSwitchChange()}
            />
          </Wrapper>
        </Wrapper>
        {isLoyaltyPromotion && renderLoyaltyForm()}
        {!isLoyaltyPromotion && renderVPTForm()}
      </Panel>
    </Collapse>
  );
}

CampaignPromotionInfoSection.propTypes = {
  promotionCampaign: PropTypes.object,
  validation: PropTypes.object,
  isLoyaltyPromotion: PropTypes.bool,
  action: PropTypes.string,
  isLoadingLoyaltyPromoCamp: PropTypes.bool,
  handleSwitchChange: PropTypes.func,
  onChange: PropTypes.func,
  onUploadFile: PropTypes.func
};

CampaignPromotionInfoSection.defaultProps = {
  promotionCampaign: {},
  validation: {},
  isLoyaltyPromotion: false,
  action: "",
  isLoadingLoyaltyPromoCamp: false,
  handleSwitchChange: () => {},
  onChange: () => {},
  onUploadFile: () => {}
};

export default CampaignPromotionInfoSection;
